import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=50549e8a"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports